import { createContext, useContext, useEffect, useState } from 'react';
import { 
    LOGO_URL, LOGO_ALT, BRAND_NAME, CARE_EMAIL, SUPPORT_EMAIL, 
    SUPPORT_PHONE, WHATSAPP_NUMBER, WHATSAPP_DISPLAY, COMPANY_LEGAL_NAME, 
    ADDRESS_MAIN, ADDRESS_SECONDARY 
} from '../constants/brand';

const initialState = { 
    logoUrl: LOGO_URL, logoAlt: LOGO_ALT, brandName: BRAND_NAME, 
    careEmail: CARE_EMAIL, supportEmail: SUPPORT_EMAIL,
    supportPhone: SUPPORT_PHONE, whatsappNumber: WHATSAPP_NUMBER,
    whatsappDisplay: WHATSAPP_DISPLAY, companyLegalName: COMPANY_LEGAL_NAME,
    addressMain: ADDRESS_MAIN, addressSecondary: ADDRESS_SECONDARY,
    loginCarouselImages: ['cartoon_1.png', 'cartoon_2.png', 'cartoon_3.png', 'cartoon_4.png', 'cartoon_5.png', 'cartoon_6.png']
};

const BrandContext = createContext(initialState);

const API_URL = process.env.REACT_APP_API_URL || '';

export function BrandProvider({ children }) {
    const [brand, setBrand] = useState(initialState);

    useEffect(() => {
        fetch(`${API_URL}/api/config/brand`)
            .then(r => r.json())
            .then(data => {
                if (data.brandName) {
                    setBrand(prev => ({ 
                        ...prev, 
                        logoUrl: data.logoUrl || prev.logoUrl, 
                        logoAlt: data.logoAlt || prev.logoAlt,
                        brandName: data.brandName || prev.brandName,
                        careEmail: data.careEmail || prev.careEmail,
                        supportEmail: data.supportEmail || prev.supportEmail,
                        supportPhone: data.supportPhone || prev.supportPhone,
                        whatsappNumber: data.whatsappNumber || prev.whatsappNumber,
                        whatsappDisplay: data.whatsappDisplay || prev.whatsappDisplay,
                        companyLegalName: data.companyLegalName || prev.companyLegalName,
                        addressMain: data.addressMain || prev.addressMain,
                        addressSecondary: data.addressSecondary || prev.addressSecondary,
                        loginCarouselImages: data.loginCarouselImages 
                            ? data.loginCarouselImages.split(',').map(s => s.trim()) 
                            : prev.loginCarouselImages
                    }));

                    // Update Chrome Tab / Document Title
                    document.title = `${data.brandName} - India's Fastest Growing Lending Platform`;

                    // Update Favicon
                    if (data.faviconUrl) {
                        let link = document.querySelector("link[rel~='icon']");
                        if (!link) {
                            link = document.createElement('link');
                            link.rel = 'icon';
                            document.head.appendChild(link);
                        }
                        // Use PUBLIC_URL if it's a relative path starting with /
                        const faviconPath = data.faviconUrl.startsWith('/') 
                            ? `${process.env.PUBLIC_URL || ''}${data.faviconUrl}` 
                            : data.faviconUrl;
                        link.href = faviconPath;
                    }
                }
            })
            .catch(err => console.error("Error loading branding:", err));
    }, []);

    return <BrandContext.Provider value={brand}>{children}</BrandContext.Provider>;
}

export function useBrand() {
    return useContext(BrandContext);
}
